import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { WorkOrderController } from "./work-order.controller";
import { WorkOrderService } from "./work-order.service";
import { WorkOrderInfo } from "./work-order.entity";
import { WorkOrderItems } from "./work-order-items.entity";
import { BaleInfo } from "../bale-generation/bale-info.entity";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { ProdlogService, ProductionInventoryService } from "@gtpl/shared-services/production";


@Module({
    imports:[
        TypeOrmModule.forFeature([WorkOrderInfo,WorkOrderItems,BaleInfo])
    ],
    controllers:[WorkOrderController],
    providers:[WorkOrderService,ApplicationExceptionHandler,ProductionInventoryService,ProdlogService],
    exports:[WorkOrderService],
})
export class WorkOrderModule{}